/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { WidgetGuard } from 'features/types'

import {
  CrosstabEmptyResultGuard,
  CrosstabLanguageNotSupportedGuard,
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  UnexpectedServiceErrorGuard,
  ThemeInaccessibleGuard
} from '../../../../share/guards'

const ComparisonModeWidgetDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <TopicIndexNotReadyGuard widgetId={widgetId}>
      <ThemeInaccessibleGuard widgetId={widgetId}>
        <UnexpectedServiceErrorGuard widgetId={widgetId}>
          <CrosstabLanguageNotSupportedGuard widgetId={widgetId}>
            <CrosstabEmptyResultGuard widgetId={widgetId}>{children}</CrosstabEmptyResultGuard>
          </CrosstabLanguageNotSupportedGuard>
        </UnexpectedServiceErrorGuard>
      </ThemeInaccessibleGuard>
    </TopicIndexNotReadyGuard>
  </TopicInaccessibleGuard>
)

export default ComparisonModeWidgetDataGuards
